import { config } from "@/config";
export const ModeloService = {
    async getModeloById(id) {
        const response = await fetch(`${config.API_URL}/api/Modelo/${id}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el modelo con id ${id}`);
        }
        const result = await response.json();
        if (!result.datos) {
            console.error('Se esperaba un objeto con la propiedad "datos" pero se recibió:', result);
            throw new Error("Formato de respuesta inesperado");
        }
        return result.datos;
    },
    async getAllModelos() {
        const response = await fetch(`${config.API_URL}/api/Modelo`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener todos los modelos");
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de modelos en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
    async addModelo(modelo) {
        const response = await fetch(`${config.API_URL}/api/Modelo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(modelo),
        });
        if (!response.ok) {
            throw new Error("Error al agregar el modelo");
        }
    },
    async updateModelo(id, modelo) {
        const response = await fetch(`${config.API_URL}/api/Modelo/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(modelo),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar el modelo");
        }
    },
    async deleteModelo(id) {
        const response = await fetch(`${config.API_URL}/api/Modelo/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            throw new Error("Error al eliminar el modelo");
        }
    },
    async GetModeloByRepuesto(repuestoID) {
        const response = await fetch(`${config.API_URL}/api/Modelo/filter?repuestoId=${repuestoID}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener el modelo");
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de modelos en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
};
